/**
* with-draw-geojson.jsx
* @author Arnaud PEZEL - Apyx (arnaud.pezel@me.com)
* @description 
* @created Tue Mar 27 2018 09:53:13 GMT+0200 (CEST)
* @last-modified Tue Mar 27 2018 09:53:13 GMT+0200 (CEST)
*/

import Vue from 'vue';
import { Watch, Prop, Component } from 'vue-property-decorator';
import OlExtent from "ol/extent";
import GeoJSON from "ol/format/GeoJSON";

@Component
export default class GeoJSONMixin extends Vue {

  protected map: any;
  protected layers: any[];
  protected viewPadding: any;

   //structured in [{ layerName: "...", geojson: ... }]
  @Prop({default: () => []}) protected readonly geojsonFeatures!: any[];

  mapProjection() { /*to be overrided*/ }

	@Watch('geojsonFeatures')
	geojsonFeaturesGeoJsonChanged() {
		this.redrawGeoJSONLayers();
	}

	@Watch('layers')
	geojsonLayersChanged() {
		this.redrawGeoJSONLayers();
	}

	redrawGeoJSONLayers() {
    if (this.geojsonFeatures && this.geojsonFeatures.length) {
      this.geojsonFeatures.forEach( desc => {
        let lyr = this.getGeoJSONLayer(desc.layerName);
        if (lyr) {
          //first clear layer
          lyr.getSource().clear();
          //append features to layer
          this.geojson2Features(desc.geojson).forEach( f => {
            desc.style && f.setStyle(desc.style);
            lyr.getSource().addFeature(f);
          });
        }
      })
		}
	}

	getGeoJSONLayer(layerName) {
		return this.layers.find( lyr => lyr.getProperties().name && lyr.getProperties().name === layerName );
	}

	onAfterMountedGeoJSON() {
		this.redrawGeoJSONLayers();
  }

  geom2geojson(geometry) {
    return new GeoJSON().writeGeometryObject(geometry);
  }

  geojson2geom(geojson) {
    return new GeoJSON().readGeometry(geojson);
  }

  geojson2Features(geojson) {
    //read the crs of the featurecollection if provided
    let dataProjection = (geojson.crs && geojson.crs.properties.name) || 'EPSG:3857';
    return new GeoJSON().readFeatures(
      geojson,
      {dataProjection, featureProjection: this.mapProjection()}
    );
  }

  features2geojson(features) {
    return new GeoJSON().writeFeaturesObject(
      features,
      {dataProjection: "EPSG:4326", featureProjection: this.mapProjection()}
    );
  }
  
  /* PUBLIC */
  fitToGeojson(geojson) {
    let extent = OlExtent.createEmpty(),
        features = this.geojson2Features(geojson);
    
    features.forEach( f => OlExtent.extend(extent, f.getGeometry().getExtent() ));

    this.map.getView().fit(
      extent,
      {
        size: this.map.getSize(),
        padding: this.viewPadding || [0, 0, 0, 0]
      }
    );
  }

	/* LIFECYCLE HOOKS */
	created() {
		//listen for map creation from base component
		this.$on('ready', this.onAfterMountedGeoJSON);
	}
}

// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-73f208d8/with-draw-geojson.tsx" });